import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const EditReportingDateDialog = ({ open, onOpenChange, date, onDateChange, onConfirm }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="edit-reporting-date-dialog">
      <DialogHeader>
        <DialogTitle className="font-heading tracking-tight">Edit reporting date</DialogTitle>
        <DialogDescription>
          Pick a new date — the label will be auto-derived (e.g. <span className="font-mono">Jun 2025</span>).
          Holdings, locks, backups and FX rates remain attached to this reporting date.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-4 py-2">
        <div>
          <Label htmlFor="edit-snap-date" className="overline">Reporting date</Label>
          <Input
            id="edit-snap-date" type="date"
            value={date}
            onChange={(e) => onDateChange(e.target.value)}
            data-testid="edit-snap-date-input"
          />
        </div>
      </div>
      <DialogFooter>
        <button className="btn-secondary" onClick={() => onOpenChange(false)}>Cancel</button>
        <button className="btn-primary" onClick={onConfirm} data-testid="edit-reporting-date-confirm">Save</button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default EditReportingDateDialog;
